import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, timeout } from 'rxjs';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = this.getTimeoutForRequest(req);

    return next.handle(req).pipe(
      timeout(timeoutValue)
    );
  }

  private getTimeoutForRequest(req: HttpRequest<any>): number {
    if (req.url.includes('/api/sap-export/validate') ||
        req.url.includes('/api/sap-export/send-to-sap')) {
      return 1800000;
    }

    if (req.url.includes('/api/sap-export/')) {
      return 300000;
    }

    return 120000;
  }
}
